<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
       <vs-list>
        <vs-list-header title="음가에 유의해 다음 단어를 말해 보세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full mb-4">
            <vx-card class="phonics-sm-card flex items-center justify-center" >
              <div class="mb-4">
                <h2 class="text-primary sentence text-center">{{ content.sentence }}</h2>
              </div>
            </vx-card>
        </div>
        <div class="vx-col sm:w-1/2 md:w-1/2 w-full mb-4">
            <vx-card class="phonics-sm-card flex items-center justify-center" >
              <flip-card :prevent-event="preventEvent" ref="flipCard">
                <template slot="front" class="phonics-sm-card">
                  <div slot="no-body">
                    <img :src="content.image" class="image-card-height">
                  </div>
                </template>
                <template slot="back">
                  <div class="mb-4">
                    <h2 class="text-primary sentence text-center"> {{ content.translation}} </h2>
                  </div>
                </template>
              </flip-card>
            </vx-card>
        </div>
      </div>
      <div>
        <div class="text-center mt-3">
          <vue-record-audio  :mode="recordMode.audio" @result="onResult" />
          <div v-show="recordingFinished" class="text-center mt-3">
            <audio ref="userAudioPlayer" :src="recording" controls v-on:ended="userAudioFinish"  />
          </div>
        </div>
        <vs-alert  v-show="audioFinished" class="mt-3 text-center" >
          위 버튼을 누른 상태에서 녹음을 진행합니다. 녹음이 끝나면 버튼을 놓으세요.
        </vs-alert>
      </div>

      <div class="text-center">
        <audio ref="audioPlayer" 
            controls
            hidden
            v-on:ended="audioFinish" 
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>

    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      recordMode: {
        audio: 'hold',
        video: 'press'
      },
      recording: '',
      audioFinished: false,
      recordingFinished: false,
      preventEvent: true
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    userAudioPlayer () {
      return this.$refs.userAudioPlayer
    }
  },
  methods: {
    onResult (data) {
      this.recording = window.URL.createObjectURL(data)
      this.recordingFinished = true
      
      setTimeout(function () {
        this.userAudioPlayer.play()
      }.bind(this), 1000)
      
    },
    onReload () {
      this.audioPlayer.pause()
      this.userAudioPlayer.pause()
      this.$refs.flipCard.resetFlip()
      this.contentIndex = 0
      this.audioFinished = false
      this.recordingFinished = false
      this.startAlert()
    },
    onStart () {
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    audioFinish () {
      this.audioFinished = true
    },
    userAudioFinish () {

      this.preventEvent = false
      setTimeout(function () {
        this.$refs.flipCard.doFlip()

        // 카드 복원
        setTimeout(function () {
          this.preventEvent = true
          this.$refs.flipCard.resetFlip()

          // 다음 문제 진행
          setTimeout(function () {
            if (this.contentIndex >= this.contentsLen - 1) {
              this.onComplete() 
            } else {
              this.contentIndex++
              this.audioFinished = false
              this.recordingFinished = false
              this.onStart()
            }
          }.bind(this), 1000)

        }.bind(this), 2000)

      }.bind(this), 1000)
    },
    startAlert () {
      this.startStudyDlg('음가에 유의해 다음 단어를 말해 보세요.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 1; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1),
        image: this.$buildImagePath(this.sourceContent.contentCode, i)
      } 
      this.contentList.push(content)
    }

    // this.contentList = [
    //   {
    //     sentence: 'you',
    //     translation: '너',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_01.mp3'
    //   },
    //   {
    //     sentence: 'slide',
    //     translation: '미끄러지다',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_02.mp3'
    //   },
    //   {
    //     sentence: 'ready',
    //     translation: '준비된',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_03.mp3'
    //   },
    //   {
    //     sentence: 'who',
    //     translation: '누구',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_04.mp3'
    //   },
    //   {
    //     sentence: 'next',
    //     translation: '다음의',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_05.mp3'
    //   },
    //   {
    //     sentence: 'turn',
    //     translation: '순서',
    //     audio: 'http://54.180.116.80:8080/contents/SP/L01/B01/U01/V04/SPL01B03U01V040_06.mp3'
    //   }
      
    // ]
    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
}

</script>

<style scoped>
.ww-jumbotron-content-sentence {
    border:1px solid #7367F0;
}
.ww-jumbotron-content-translation {
    border:1px solid #28C76F;
}
.tc-ww-input {
    height: 50px;
    width: 200px;
    font-size: 30px;
    text-align: center;
    letter-spacing:10px;
} 
</style>